<template>

<div id='contact-page' class='page'>
	<div>
		<go-back/>
		<h6 class='heading'>{{$t('h-contact')}}</h6>
	</div>
	<div class="page-content">
		<section>
			
            <p>{{$t('contact-content-1')}}<br><br>{{$t('contact-content-2')}}</p>
			<br>
			
			<ul class="list1">
				<li><span>{{$t('contact-content-3')}}</span><a href='mailto:timawbi@gmail.com'>timawbi@gmail.com</a></li>
				<li><span>{{$t('contact-content-4')}}</span><a href="https://www.facebook.com/timambi">Tim Vma</a></li>
			</ul>
		
		
		</section>
	</div>
	
		
	<div class="overlay">Eメール</div>

</div>






</template>

<script>
import GoBack from '@/components/GoBack'
export default {
	components: { 
		GoBack
	}
}
</script>
